module.exports = __webpack_public_path__ + "static/media/hygiene-on-hover.5822a18d.png";